export default class Ratchet {
    constructor(adapter) {
        this.client = adapter.getRatchetClient()
    }

    async query(name, params) {
        let res = await this.client.post('/query', {
            name: name,
            params: params
        })

        return res.data
    }
}